// extracted by mini-css-extract-plugin
export var cardHeader = "_gq-0";
export var reorderHandle = "_gq-3";
export var titleArea = "_gq-1";
export var titleAreaWithHandle = "_gq-2";